import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js';
import './toast.css';
import {getSshkeys,addSshkey,clearSshErr} from '../store/sshkeyActions';
import SshKeyItem from './SshKeyItem';

const SshKeyUpdate = ({keys,error,getSshkeys,addSshkey,clearSshErr}) => {
  const [sshkey, setSshkey] = useState('');
  const [keysz, setKeysz] = useState(null);

  const KMAX=1024;
  const KMIN=300;
  const NUMK=10;
  let minsz=0;

  useEffect(()=>{
    getSshkeys();
  //eslint-disable-next-line
  },[]);

  useEffect(()=>{
    if(error!==null) {
      M.toast({html: `${error}`, classes: 'red darken-2', displayLength: 5000});
      clearSshErr();
    }
    //getProjects();
  //eslint-disable-next-line
  },[error])

  useEffect(()=>{
    if(keysz!==null) {
      M.toast({html: `${keysz}`, classes: 'red darken-2', displayLength: 5000});
    }
    setKeysz(null);
  //eslint-disable-next-line
  },[keysz])

  const onChange = (e) => setSshkey(e.target.value)
  const onSubmit = (e) => {
    e.preventDefault();
    let rsa=false;
    if(sshkey.startsWith('ssh-rsa ')){
      rsa=true;
      minsz=KMIN;
    }
    let sz=sshkey.trim().length;
    if(sz>KMAX){setKeysz('key length exceed limit')}
    //if(sz<KMIN){setKeysz('RSA key length less than minimum length')}
    if(rsa && sz<minsz){setKeysz('RSA key length less than minimum length')}
    if(keys.length>=NUMK){setKeysz('number of keys reached limit')}
    if(sz>=minsz && sz<=KMAX && keys.length < NUMK ){ addSshkey({sshkey:sshkey.trim()}); }
    setTimeout(()=>getSshkeys(), 500)
    setSshkey('');
  }

  return (
    <>
      <div className='form-container'>
        <form onSubmit={onSubmit}>
          <div className='form-group'>
            <label htmlFor='token'>Add an ssh public key, maximum size: {KMAX} bytes, maximum number of keys: {NUMK}, RSA key minimum size: {KMIN} bytes</label>
            <input type='text' name='sshkey' value={sshkey} onChange={onChange} required />
          </div>
          <input type='submit' value='add sshkey' className='btn btn-primary btn-block' />
        </form>
      </div>

      <div style={{'margin':'50px 0px 50px 0px'}}></div>
      <div className='row'>
        {keys && keys.map((v,i)=>(<div key={10+i}> <SshKeyItem sshkey={v} /></div>))}
      </div>

    </>
  );
};

const mapStoreToProps = state => ({
  keys: state.sshkey.keys,
  error: state.sshkey.error
});

export default connect(mapStoreToProps,{getSshkeys,addSshkey,clearSshErr})(SshKeyUpdate)

